import { render } from "./BuildModal.vue?vue&type=template&id=41d5c9db&scoped=true"
import script from "./BuildModal.vue?vue&type=script&lang=js"
export * from "./BuildModal.vue?vue&type=script&lang=js"

import "./BuildModal.vue?vue&type=style&index=0&id=41d5c9db&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d5c9db"]])

export default __exports__